import React, { useState } from "react";
import { updateUserRole, revokeAdmin } from "services/userService";
import * as Sentry from "@sentry/react";

const AdminControlCell = ({ user, locations, refreshUsers }) => {
  const [selectedLocation, setSelectedLocation] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);

  const handlePromote = async (locationId) => {
    try {
      await updateUserRole(user.id, {
        role: "admin",
        adminFor: locationId,
      });
      refreshUsers();
    } catch (error) {
      Sentry.captureException(error);
      console.error("Erreur promotion admin:", error);
    }
  };

  const handleRevoke = async () => {
    try {
      await revokeAdmin(user.id);
      refreshUsers();
    } catch (error) {
      Sentry.captureException(error);
      console.error("Erreur suppression admin:", error);
    }
  };

  return (
    <td className="p-2">
      {user.adminFor ? (
        <div className="flex items-center justify-between space-x-2">
          <span className="text-green-400 text-sm">{user.adminFor}</span>
          <button
            onClick={handleRevoke}
            className="bg-red-600 hover:bg-red-700 text-white px-2 py-1 text-xs rounded"
          >
            Retirer admin
          </button>
        </div>
      ) : showDropdown ? (
        <select
          value={selectedLocation}
          onChange={(e) => {
            const value = e.target.value;
            setSelectedLocation(value);
            if (value) handlePromote(value);
          }}
          className="bg-gray-700 text-white px-2 py-1 rounded border border-gray-600 text-sm"
        >
          <option value="">Sélectionnez une location</option>
          {locations.map((t) => (
            <option key={t.id} value={t.id}>
              {t.name}
            </option>
          ))}
        </select>
      ) : (
        <button
          onClick={() => setShowDropdown(true)}
          className="bg-amber-600 hover:bg-amber-700 text-white px-3 py-1 text-xs rounded"
        >
          Ajouter comme admin
        </button>
      )}
    </td>
  );
};

export default AdminControlCell;
